
import respUtility from '~/mixins/respUtility';
import { htmlspecialcharsDecode } from '@/mixins/helpers';
// eslint-disable-next-line import/extensions
import { debounce } from '../../../../vue/mixins/helpers.js';

export default {
  name: 'ListingTitle',
  mixins: [respUtility],
  props: {
    header: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isSearchParams: {
      type: Boolean,
      default: false,
    },
    seoData: {
      type: Object,
    },
  },
  data() {
    return {
      isShow: false,
      isLongText: true,
      innerWidth: 0,
    };
  },
  computed: {
    text() {
      let str = ';';
      if (this.$store.state.pageData.type === 'search' && !(this.$device.isMobileOrTablet || this.isTouchDevice)) {
        str = `Results for “${this.header}”`;
      } else {
        str = this.header;
      }
      return htmlspecialcharsDecode(str);
    },
  },
  mounted() {
    this.checkSeoText();
    this.checkSize = debounce(this.checkSeoText, 200);
    window.addEventListener('resize', this.checkSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkSize);
  },
  watch: {
    'seoData.content': function seoDataWatcher() {
      this.$nextTick(this.checkSeoText);
    },
  },
  methods: {
    checkSeoText() {
      if (window.innerWidth === this.innerWidth) {
        return;
      }
      this.innerWidth = window.innerWidth;
      const wrapper = this.$refs?.seoText?.$el;
      if (wrapper) {
        this.isLongText = wrapper.scrollHeight > wrapper.clientHeight;
      }
    },
  },
};
